// Centralized UI effect classes to avoid duplicated shadows/lighting across components

export const glassPanelClass = 'glass-panel rounded-xl';
// switched to GPU-friendly shadow implementation (uses ::before pseudo-element)
export const commonShadow = 'cheap-shadow';
// If you need the old (heavier) shadow, use `commonShadowStrong` explicitly
export const commonShadowStrong = "shadow-[0_10px_30px_rgba(197,160,33,0.18)]";
export const goldGlow = 'absolute inset-0 bg-gold opacity-20 transition-opacity rounded-full';
export const goldButtonClass = 'bg-gradient-to-r from-gold to-[#D4AF37] rounded-full border border-white/20';
